<template>
    <div class="setpwd-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('setpwd.modifyLoginPassword') }}</div>
        </header>

        <main class="page-content">
            <section class="form-card">
                <div class="card-header">
                    <div>
                        <h1>{{ $t('setpwd.setNewLoginPassword') }}</h1>
                        <p>{{ getLabel('pageSetpwd.modeHint', '请根据当前账户状态选择更适合的修改方式。') }}</p>
                    </div>
                    <button type="button" class="switch-mode" @click="cutType(codeStatus ? 2 : 1)">
                        {{ codeStatus ? $t('setpwd.useoriginalpassword') : $t('setpwd.usemobilenumber') }}
                    </button>
                </div>

                <div v-if="codeStatus" class="section-block">
                    <label class="field-label">{{ $t('setpwd.boundmobilenumber') }}</label>
                    <div class="info-box">{{ ycmobile || '--' }}</div>

                    <label class="field-label">{{ $t('setpwd.SMSverificationcode') }}</label>
                    <div class="code-wrap">
                        <input
                            v-model.trim="code"
                            type="text"
                            class="text-input"
                            :placeholder="$t('setpwd.SMSverificationcode')"
                        >
                        <van-count-down :time="time" class="countdown" @finish="timeCall">
                            <template v-slot="timeData">
                                <button
                                    type="button"
                                    class="code-btn"
                                    :disabled="timeData.seconds > 0 || is_send"
                                    @click="sendcode"
                                >
                                    {{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('setpwd.sendcode') }}
                                </button>
                            </template>
                        </van-count-down>
                    </div>
                </div>

                <div v-else class="section-block">
                    <label class="field-label">{{ $t('setpwd.originalloginpassword') }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="password"
                            :type="passwordInp"
                            class="text-input"
                            :placeholder="$t('setpwd.originalloginpassword')"
                        >
                        <button type="button" class="eye-btn" @click="showPwd">
                            <van-icon :name="passwordInp === 'password' ? 'closed-eye' : 'eye'" />
                        </button>
                    </div>
                </div>

                <div class="section-block newpwd-block">
                    <label class="field-label">{{ $t('setpwd.newpassword') }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="npassword"
                            :type="newpasswordInp"
                            class="text-input"
                            :placeholder="$t('setpwd.newpassword')"
                        >
                        <button type="button" class="eye-btn" @click="showNewsPwd">
                            <van-icon :name="newpasswordInp === 'password' ? 'closed-eye' : 'eye'" />
                        </button>
                    </div>

                    <label class="field-label">{{ $t('setpwd.confirmnewpassword') }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="rpassword"
                            :type="newpasswordInp"
                            class="text-input"
                            :placeholder="$t('setpwd.confirmnewpassword')"
                        >
                        <button type="button" class="eye-btn" @click="showNewsPwd">
                            <van-icon :name="newpasswordInp === 'password' ? 'closed-eye' : 'eye'" />
                        </button>
                    </div>
                </div>
            </section>

            <button
                v-if="codeStatus"
                type="button"
                class="submit-btn"
                :class="{ disabled: !rpassword || !code || !npassword }"
                @click="dxRevise"
            >
                {{ $t('setpwd.modify') }}
            </button>
            <button
                v-else
                type="button"
                class="submit-btn"
                :class="{ disabled: !password || !rpassword || !npassword }"
                @click="oldRevise"
            >
                {{ $t('setpwd.modify') }}
            </button>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Icon, Toast } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Icon).use(Toast);

export default {
    name: "setpwd",
    data() {
        return {
            time: 0,
            password: "",
            rpassword: "",
            npassword: "",
            mobile: "",
            ycmobile: "",
            passwordInp: "password",
            newpasswordInp: "password",
            codeStatus: true,
            code: "",
            is_send: false,
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        Fetch("/user/info").then((r) => {
            this.mobile = (r.data && r.data.mobile) || "";
            this.ycmobile = this.mobile ? this.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") : "";
        });
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        cutType(n) {
            this.codeStatus = n === 1;
            this.rpassword = "";
            this.npassword = "";
            this.password = "";
            this.code = "";
        },
        timeCall() {
            this.is_send = false;
            this.time = 0;
        },
        sendcode() {
            if (this.is_send) {
                return;
            }
            this.is_send = true;
            Fetch("/index/register_code").then(() => {
                this.time = 60 * 1000;
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.sendsuccessfully"),
                });
            }).catch(() => {
                this.is_send = false;
            });
        },
        showPwd() {
            this.passwordInp = this.passwordInp === "password" ? "text" : "password";
        },
        showNewsPwd() {
            this.newpasswordInp = this.newpasswordInp === "password" ? "text" : "password";
        },
        dxRevise() {
            if (!this.npassword) {
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.newpasswordcannotbeempty"),
                });
                return false;
            }
            if (this.npassword !== this.rpassword) {
                this.$toast(this.$t("setpwd.inconsistent"));
                return false;
            }
            Fetch("/index/forgetpwd", {
                code: this.code,
                password: this.npassword,
            }).then(() => {
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.modifiedsuccessfully"),
                });
                this.$router.replace("/safe");
            });
        },
        oldRevise() {
            if (!this.password) {
                this.$toast(this.$t("setpwd.originalpasswordcannotbeempty"));
                return false;
            }
            if (!this.npassword) {
                this.$toast(this.$t("setpwd.newpasswordcannotbeempty"));
                return false;
            }
            if (this.npassword !== this.rpassword) {
                this.$toast(this.$t("setpwd.inconsistent"));
                return false;
            }
            Fetch("/user/repasswd", {
                passwd: this.password,
                npasswd: this.npassword,
            }).then(() => {
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.modifiedsuccessfully"),
                });
                this.$router.replace("/safe");
            });
        },
    },
};
</script>

<style lang="less" scoped>
.setpwd-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.form-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
}

.form-card {
    padding: 22px 18px;
    margin-bottom: 18px;
}

.card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 22px;
}

.card-header h1 {
    margin: 0 0 8px;
    font-size: 24px;
    font-weight: 800;
    color: #fff;
}

.card-header p {
    margin: 0;
    color: rgba(255, 255, 255, 0.52);
    font-size: 12px;
    line-height: 1.7;
}

.switch-mode {
    min-width: 104px;
    height: 34px;
    padding: 0 12px;
    border: 0;
    border-radius: 10px;
    background: rgba(45, 91, 255, 0.12);
    color: #2d5bff;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
}

.section-block + .section-block {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.field-label {
    display: block;
    margin: 0 0 10px 2px;
    color: rgba(255, 255, 255, 0.88);
    font-size: 14px;
}

.info-box,
.input-wrap,
.code-wrap {
    min-height: 54px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.02);
}

.info-box {
    display: flex;
    align-items: center;
    padding: 0 16px;
    color: #2d5bff;
    font-size: 15px;
    font-weight: 700;
}

.input-wrap,
.code-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 12px 0 16px;
}

.newpwd-block .input-wrap + .field-label {
    margin-top: 14px;
}

.text-input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: 0;
    outline: none;
    background: transparent;
    color: #fff;
    font-size: 15px;
}

.text-input::placeholder {
    color: rgba(255, 255, 255, 0.28);
}

.eye-btn,
.code-btn {
    border: 0;
    background: transparent;
    flex-shrink: 0;
}

.eye-btn {
    width: 34px;
    height: 34px;
    color: rgba(255, 255, 255, 0.54);
    display: flex;
    align-items: center;
    justify-content: center;
}

.eye-btn .van-icon {
    font-size: 20px;
}

.countdown {
    flex-shrink: 0;
}

.code-btn {
    min-width: 98px;
    height: 38px;
    padding: 0 12px;
    border-radius: 10px;
    background: rgba(45, 91, 255, 0.12);
    color: #2d5bff;
    font-size: 13px;
    font-weight: 700;
}

.code-btn[disabled] {
    opacity: 0.6;
}

.submit-btn {
    width: 100%;
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #2d5bff 0%, #104af0 100%);
    box-shadow: 0 4px 15px rgba(45, 91, 255, 0.3);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.submit-btn.disabled {
    opacity: 0.55;
}
</style>
